export const initialDashboardState = {
    data: {
        dashboardTileDTOList: [],
        usersPerHour: {},
        usersPerHourCumulative: {},
        deviceCount: {},
        userFilesCount: []
    },
    loading: false
}